import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
// import VueRouter from 'vue-router'
// import ListaCertificados from './components/ListaCertificados.vue'
import App from './App.vue'
// import { publicPath } from '../vue.config'
import dotenv from 'dotenv'
import Keycloak from 'keycloak-js'
import VueAnalytics from 'vue-analytics';

dotenv.config();

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

// Configuration VueAnalytics
Vue.use(VueAnalytics, {
  id: 'UA-174598604-3'
});

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

// Rotas

// const router = new VueRouter({
//   mode: 'history',
//   base: publicPath,
//   routes: [
//     { path: '/logout', component: App, props: true }
//   ]
// })


// Keycloack

let initOptions =   {
  url: process.env.VUE_APP_API_AMEIURL,
  realm: process.env.VUE_APP_API_AMEIREALM,
  clientId:  process.env.VUE_APP_API_AMEICLIENTID        
}

let keycloak = Keycloak(initOptions);

Vue.prototype.$keycloak = keycloak;

keycloak.init({ onLoad: 'login-required', promiseType: 'native' }).then((auth) => {

  if (!auth) {
    window.location.reload();
  } else {
    new Vue({
      //router,
      render: h => h(App, { props: { keycloak: keycloak } }),
    }).$mount('#app')
  }

}).catch((erro) => {
  console.log('Ocorreu erro de autenticação:' + erro);
});








